import { useMemo, useEffect } from 'react'
import {
	useGridApiContext,
	useGridSelector,
	gridPageSelector,
	gridPageCountSelector,
	gridPageSizeSelector,
	GridPagination,
} from '@mui/x-data-grid-premium'

export const PAGE_SIZE_LIST = [25, 50, 100, 200, 300, 500, 1000]
export const DEFAULT_PAGE_SIZE = 100

export function CustomPagination(props) {
	const {
		hasMoreRecords,
		onHandleLoadRecordsByPagination,
		setPaginationModel,
		isLoading,
		allRecordsLoading,
		showInfoMessage,
		setScrollPosition,
	} = props
	const apiRef = useGridApiContext()
	const page = useGridSelector(apiRef, gridPageSelector)
	const pageCount = useGridSelector(apiRef, gridPageCountSelector)
	const pageSize = useGridSelector(apiRef, gridPageSizeSelector)

	const disableNextButton = useMemo(() => {
		if (isLoading || allRecordsLoading) return true
		const isLastPage = page + 1 === pageCount
		if (isLastPage) return !hasMoreRecords

		return false
	}, [isLoading, allRecordsLoading, hasMoreRecords, page, pageCount])

	return (
		<GridPagination
			slotProps={{
				actions: {
					nextButton: {
						onClick: () => {
							const nextPage = page + 1
							onHandleLoadRecordsByPagination?.(pageSize, nextPage, true).then(() => {
								setPaginationModel({
									page: nextPage,
									pageSize,
								})
								setScrollPosition?.()
							})
						},
						disabled: disableNextButton,
					},
					previousButton: {
						onClick: () => {
							const previousPage = page - 1
							setPaginationModel({
								page: previousPage,
								pageSize,
							})
							setScrollPosition?.()
						},
						disabled: page === 0,
					},
				},
				select: {
					onChange: (event) => {
						if (isLoading || allRecordsLoading) {
							showInfoMessage?.()
							return
						}
						const newPageSize = Number(event.target.value)
						onHandleLoadRecordsByPagination?.(newPageSize)
						setPaginationModel({
							page: 0,
							pageSize: newPageSize,
						})
						setScrollPosition?.()
					},
				},
			}}
		/>
	)
}
